/**
 * @file filterChip.component.tsx
 * @path apps/website/src/features/experiences/components/filterChip.component.tsx
 */
import { cn } from "@sirbastians/utils";
import { X } from "lucide-react";

export const FilterChip = ({
  label,
  active,
  onRemove,
}: {
  label: string;
  active?: boolean;
  onRemove: () => void;
}) => (
  <div
    className={cn(
      "flex items-center gap-2 px-4 py-2 rounded-full border text-[10px] uppercase tracking-widest font-medium transition-all",
      active
        ? "bg-accent border-accent text-accent-foreground"
        : "bg-muted border-border text-muted-foreground",
    )}
  >
    {label}
    <X
      className="h-3 w-3 cursor-pointer hover:scale-125 transition-transform"
      onClick={onRemove}
    />
  </div>
);
